<app-header [forceLightBackground]="true"></app-header>
<div class="provider-activities">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="provider-activities--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="provider-activities--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true"></app-activities>
    </div>
  </div>
</div>
